import React from "react";

import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const FloorCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    const floor = property.floor === 0 ? "Parter" : `${property.floor} piętro`;

    return <>{property.floor === null ? null : floor}</>;
};
import React from "react";

import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const FloorCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    const floor = property.floor === 0 ? "Parter" : `${property.floor} piętro`;

    return <>{property.floor === null ? null : floor}</>;
};
